<h5 *ngIf="categoryTemplateRef?.templateRef" class="__category">

  <mat-icon
    *ngIf="!!icon"
    class="__icon">
    storage
  </mat-icon>

  <ng-template [ngTemplateOutlet]="categoryTemplateRef?.templateRef"></ng-template>

</h5>

<div class="__name  c-service-stack-tile-name" *ngIf="nameTemplateRef">
  <ng-template [ngTemplateOutlet]="nameTemplateRef?.templateRef"></ng-template>
</div>

<div
  *ngIf="techIcons?.length"
  class="__tech-icons">
  <mat-icon
    *ngFor="let icon of techIcons; trackBy: trackBy"
    class="__tech-icon"
    [svgIcon]="icon">
  </mat-icon>
</div>
